const vehicleTypeOptionItems = [
  {
    label: 'Sedan',
    value: 'sedan',
  },
  {
    label: 'SUV',
    value: 'suv',
  },
  {
    label: 'Truck',
    value: 'truck',
  },
  {
    label: 'Motorcycle',
    value: 'motorcycle',
  },
];

export default vehicleTypeOptionItems;
